import { render, staticRenderFns } from "./SiteNav.vue?vue&type=template&id=43481a50&scoped=true&"
import script from "./SiteNav.vue?vue&type=script&lang=js&"
export * from "./SiteNav.vue?vue&type=script&lang=js&"
import style0 from "./SiteNav.vue?vue&type=style&index=0&id=43481a50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43481a50",
  null
  
)

export default component.exports